;(function() {
    function FlipFlop_init(node) {
        let state = {
            $root: $(node),
            $track: $(node).find('.js-FlipFlop-track'),
        }

        state.$root.css({'position': 'relative'})
        state.$track.css({'overflow-x': 'hidden'})

        let $toggle = $('<button/>')
            .css({position: 'absolute', right: '24px', bottom: '64px'})
            .addClass("FlipFlop-toggle")
            .text("Toggle")
            .appendTo(state.$root)

        $toggle.on('click', function(event) {
            let root = state.$track[0];
            let client_width = root.clientWidth;
            let scroll_width = root.scrollWidth;
            let scroll_offset = root.scrollLeft;

            let scroll_amount = 0;
            $toggle.css({ 'backgroundImage': 'url("/assets/build/images/icons/icon-17-tippyright@2x.png")' })

            if (scroll_offset === 0) {
                scroll_amount = scroll_width - client_width;
                $toggle.css({ 'backgroundImage': 'url("/assets/build/images/icons/icon-17-tippyleft@2x.png")' })
            }

            state.$track.animate({ scrollLeft: scroll_amount + 'px' }, 125);
        })
    }


    let $flip_floppers = $('.js-FlipFlop');

    for (let i = 0; i < $flip_floppers.length; ++i) {
        FlipFlop_init($flip_floppers[i]);
    }
}())